<template>
  <div id="app">
    <!-- <commonLayout /> -->
    <router-view />
    <notifications animation-name="v-fade-bottom" position="bottom center">
      <template slot="body" slot-scope="props">
        <div
          :class="[
            'flex flex-row items-center justify-center relative text-white my-2 rounded-md p-5',
            {
              'bg-red-500': props.item.type === 'error',
              'bg-green-500': props.item.type === 'success',
              'bg-yellow-500': props.item.type === 'warn',
            },
          ]"
        >
          <div class="px-5">
            <p class="text-center">
              {{
                props.item.title.charAt(0).toUpperCase() +
                props.item.title.slice(1)
              }}
            </p>
            <p v-if="props.item.text" class="text-center">
              {{
                props.item.text?.charAt(0).toUpperCase() +
                props.item.text?.slice(1)
              }}
            </p>
          </div>
          <a
            class="close absolute right-4 hover:bg-gray-200 cursor-pointer hover:text-black rounded-full p-1"
            @click="props.close"
          >
            <i class="fa fa-close"></i>
          </a>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "App",
  watch: {
    "$route.query": {
      handler(newVal, oldVal) {
        if (newVal.p !== oldVal.p) {
          this.fetchRolePermissions({
            type: this.$route.query.view,
            project_id: newVal.p,
            org_id: this.$route.query.o,
          });
        }

        if (newVal.o !== oldVal.o) {
          this.fetchRolePermissions({
            type: this.$route.query.view,
            project_id: this.$route.query.p,
            org_id: newVal.o,
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      fetchRolePermissions: "common/fetchRolePermissions",
    }),
  },
};
</script>

<style lang="postcss">
@import "./index.css";
@import "primevue/resources/primevue.min.css";
@import "primevue/resources/themes/tailwind-light/theme.css";
</style>

<style lang="scss">
.my-style {
  padding: 20px;
  margin: 10px;
  font-size: 14px;
  color: #ffffff;
  background: #44a4fc;
  text-align: center;
  z-index: 999;
  border-radius: 6px;

  .notification-title {
    text-align: center;
  }

  .notification-content {
    text-align: center;
  }

  &.warn {
    background: #ffb648;
  }

  &.error {
    background: #e54d42;
    font-weight: 700;
  }

  &.success {
    background: #68cd86;
  }
}

button:disabled {
  background-color: rgb(92, 92, 92);
  cursor: not-allowed;
}
</style>
